import axiosInstance from 'src/axios-instance';
import { LogMessage } from './types';

const simpleLog = (msg: LogMessage) => {
  axiosInstance.post('/proxy/log', msg).catch(() => null);
};

export default simpleLog;
